import { Box, Button, Stack, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import ArrowsIconPng from "../../assets/icons/services/arrows.png";
import ComputerIconPng from "../../assets/icons/services/computer.png";
import EyeIconPng from "../../assets/icons/services/eye.png";
import CardGroup from "../shared/CardGroup";
import Container from "../shared/Container";

const BenefitsSection: FC = () => {
  const { t } = useTranslation("home");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Container sx={{ position: "relative", py: { xs: 8, md: 10 }, mb: 2 }}>
      <Stack spacing={{ xs: 4, md: 8 }} alignItems="center">
        <Stack spacing={2} maxWidth={800} sx={{ mx: "auto" }}>
          <Typography
            fontFamily="Epilogue"
            fontSize={40}
            fontWeight={700}
            lineHeight={1.2}
            textAlign="center"
          >
            <span style={{ color: "#00DB97" }}>{t("see_the_benefits")}</span>{" "}
            {t("from_ebinex")}
          </Typography>
          <Typography fontSize={16} lineHeight={1.5} textAlign="center">
            {t("see_the_benefits_description")}
          </Typography>
        </Stack>
        <Box>
          <CardGroup
            items={[
              {
                icon: ComputerIconPng,
                title: t("trading_interface"),
                text: t("trading_interface_description"),
              },
              {
                icon: ArrowsIconPng,
                title: t("trading_indicators"),
                text: t("trading_indicators_description"),
              },
              {
                icon: EyeIconPng,
                title: t("low_delay"),
                text: t("low_delay_description"),
              },
            ]}
          />
        </Box>
        <Button
          component={RouterLink}
          to="/register"
          variant="contained"
          size={isMobile ? "medium" : "large"}
          sx={{ zIndex: 5 }}
        >
          {t("open_your_account_in_less_than_1_minute")}
        </Button>
      </Stack>
    </Container>
  );
};

export default BenefitsSection;
